import { useMemo } from 'react';
import { useCurrentRoute } from 'react-navi';

export const useIsLanding = () => {
  const {
    url: { pathname },
  } = useCurrentRoute();

  const isLanding = useMemo(() => pathname.includes('/promo/'), [pathname]);

  return { isLanding };
};
